import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import MoneyFlow from "../components/MoneyFlow";

/**
 * Scene 64 — "And that's where we win."
 */

export default function Scene64_WhereWeWin() {
  return (
    <SceneShell variant="gold" align="center" data-testid="scene-where-we-win">
      <MoneyFlow density={32} color="rgba(255,232,168,0.85)" symbol="£" />

      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(255,232,168,0.30) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(255,232,168,0.55) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(255,232,168,0.30) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Concentric rings */}
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className="absolute top-1/2 left-1/2 rounded-full border pointer-events-none"
          style={{
            width: 280,
            height: 280,
            borderColor: "rgba(0,0,0,0.30)",
            translate: "-50% -50%",
          }}
          animate={{ scale: [1, 4], opacity: [0.45, 0] }}
          transition={{
            duration: 4.5,
            repeat: Infinity,
            ease: "easeOut",
            delay: 0.8 + i * 1.4,
          }}
        />
      ))}

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        <motion.h2
          initial={{ opacity: 0, scale: 0.78, filter: "blur(24px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.4, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display leading-[1.0] pb-2"
          style={{
            fontSize: "clamp(64px, 9vw, 140px)",
            color: "#0d0d0f",
            textShadow: "0 8px 60px rgba(0,0,0,0.32)",
            fontWeight: 900,
          }}
          data-testid="where-we-win-headline"
        >
          And that's
          <br />
          where{" "}
          <span style={{ color: "#7a3a05" }}>we win.</span>
        </motion.h2>
      </div>
    </SceneShell>
  );
}
